// extracted by mini-css-extract-plugin
export default {"PlainFeature":"wb_a bhk_b"};